var map = {
	"./fifa21.png": "5c7d",
	"./logo/fifa21.png": "7d99",
	"./logo/nba21.png": "4d16",
	"./logo/nhl21.png": "421a",
	"./logo/ufc4.png": "1eab",
	"./mobile-card/fifa21.png": "b40a",
	"./mobile-card/nba21.png": "5669",
	"./mobile-card/nhl21.png": "0f4a",
	"./mobile-card/ufc4.png": "803d",
	"./nba21.png": "099e",
	"./nhl21.png": "30e4",
	"./pattern.png": "ae2c",
	"./ufc4.png": "5d71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36cc";